import $ from 'jquery';

$(function () {
  if (
    $('.bulk_updates.new, .bulk_creations.new, .bulk_reporting_groups.new')
      .length
  ) {
    $('.js-file-input').on('change', function (e) {
      $('.js-preview-bulk-update').prop('disabled', false);
      var fileName = e.target.value.split('\\').pop().split('/').pop();
      $('.js-file-name').text(fileName);
    });
  }
});
